import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import {
  showContextualAttribute,
  hideContextualAttribute,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';
import template from '../template/index.pug';
import AdExtensionEditorView from './AdExtensionEditorView';

export default class AdExtensionInlineView extends Backbone.View {
  initialize({
    deps,
    i18n,
    data,
    type,
    router,
    isMCC,
    gridView,
    gridService,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.data = data;
    this.type = type;
    this.router = router;
    this.isMCC = isMCC;
    this.grid = { gridView };
    this.extensionData = {};
    this.gridService = gridService;

    if (data && data.Opportunities.length > 0) {
      const opt = data.Opportunities[0];
      this.extensionData.ids = [opt.OpportunityId];
      this.extensionData.idOpportunityMap = {};
      this.extensionData.idOpportunityMap[opt.OpportunityId] = {
        CampaignId: data.Target.CampaignId,
        Competitors: opt.Competitors,
        EstimatedKPI: {
          CtrLift: opt.CtrLift,
          Clicks: opt.CurrentClicks,
          ClickDelta: opt.EstimatedIncreaseInClicks,
          ClicksNew: opt.CurrentClicks + opt.EstimatedIncreaseInClicks,
          CTR: opt.CurrentCtr,
          CTRDelta: opt.EstimatedIncreaseInCtr,
          CTRNew: opt.CurrentCtr + opt.EstimatedIncreaseInCtr,
          Cost: opt.CurrentCost,
          CostDelta: opt.EstimatedIncreaseInCost,
          CostNew: opt.CurrentCost + opt.EstimatedIncreaseInCost,
          CPC: opt.CurrentCpc,
          CPCDelta: opt.EstimatedIncreaseInCpc,
          CPCNew: opt.CurrentCpc + opt.EstimatedIncreaseInCpc,
        },
      };
    }
  }

  get events() {
    return {
      'click .btn-cancel': 'cancel',
      'click .apply': 'apply',
      'mouseover .ad-extension-opt-detail .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .ad-extension-opt-detail .contextual-tooltip': 'hideContextualAttributePopup',
      'click .ad-extension-opt-detail .contextual-tooltip': 'scopeRouting',
    };
  }

  scopeRouting(e) {
    this.router(e);
  }

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.data.OpportunityType,
        isExpanding: true,
        self: this,
        recommendationService: this.gridService.recommendationService,
      });
    }, 500);
  }

  apply(e) {
    this.adExtensionEditorView.apply(e);
    this.trigger('apply', { opportunities: this.data.Opportunities });
  }

  cancel() {
    this.trigger('cancel');
  }

  hasChanged() {
    return this.adExtensionEditorView.viewModel.isApplyEnable();
  }

  render() {
    this.$el.html(template(_.extend({
      i18n: this.i18n,
    })));

    this.adExtensionEditorView = new AdExtensionEditorView({
      deps: this.deps,
      data: this.data,
      i18n: this.i18n,
      el: this.$('.ad-extension-opt-detail'),
      opportunities: this.extensionData,
      type: this.type,
      isMCC: this.isMCC,
    });
    this.adExtensionEditorView.render();
    ko.applyBindings(this.adExtensionEditorView.viewModel, this.$('.ad-extension-detail-actions')[0]);
    return this;
  }
}
